import { render } from "./Chatroom.vue?vue&type=template&id=cba8db50"
import script from "./Chatroom.vue?vue&type=script&lang=js"
export * from "./Chatroom.vue?vue&type=script&lang=js"
script.render = render

export default script